<template lang="pug">
  .record-download-page.flex.align-start.column.gap-20
    .desc 選擇年份和月份，將下載選定範圍內的活動列表
    .flex.align-center.gap-12
      el-date-picker(format="yyyy-MM", v-model="month", type="month", placeholder="選擇年份和月份")
      el-button(type="primary", @click="downloadFile") 下載檔案
  </template>

<script>
import {
  getMonthActivities,
} from '@/api/archive';

export default {
  data() {
    return {
      month: undefined,
    };
  },
  methods: {
    downloadFile() {
      if (!this.month) {
        this.$showWarn('請先選擇年份和月份');
        return;
      }
      const start = this.month;
      start.setMonth(start.getMonth(), 1);
      start.setHours(0, 0, 0, 0);
      const end = new Date(start);
      end.setMonth(start.getMonth() + 1, 1);
      this.$execWithLoading(async () => {
        const data = await getMonthActivities(this.$dateToTimestamp(start), this.$dateToTimestamp(end));
        const csv = this.arrayToCsv(data);
        // 加上 UTF-8 BOM，Excel 直接開啟時中文才不會亂碼
        const blob = new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `activities-${this.month.getFullYear()}-${this.month.getMonth() + 1}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
      }, (e) => {
        this.$showAxiosException('下載檔案失敗', e);
      });
    },
    arrayToCsv(datas) {
      const header = ['id', 'name', 'professional', 'start_at', 'end_at', 'location_type', 'price', 'price_model', 'organization', 'description', 'note', 'branch', 'space_name', 'city', 'district', 'address'];
      const rows = datas.map((d) => {
        const row = [];
        header.forEach((h) => {
          // 只把 null／undefined 視為空白，0 與 false 照實輸出
          const value = (d[h] === null || d[h] === undefined) ? '' : d[h];
          row.push(`"${value.toString().replace(/"/g, '""')}"`);
        });
        return row;
      });
      return [header, ...rows].map((r) => r.join(',')).join('\n');
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
